module.exports = __webpack_public_path__ + "img/41.f814ec20.png";